export default "__VITE_ASSET__Z$_eJsYA__"